export class BasicModalModel {
    title: string;
    message: string;
    ok: string;
  
    constructor(title: string, message: string, ok?: string) {
      this.title = title;
      this.message = message;
      if(ok){
        this.ok = ok;
      } else {
        this.ok = 'OK';
      }
    }
}
  